<template>
	<div class="container">
		 <div class="breadBox">
		    <div class="breadItem"><span>订单管理</span></div>
		    <div class="breadItem"><span>订单列表</span></div>
		</div>
		<div class="searchBox">
            {{currentFunction}}
			<div class="left">
				<el-form :inline="true">
					</el-form-item>
					<el-form-item>
						<el-input class="fuzzyInput" placeholder="订单号/订单名称/发单方/手机号" v-model="formObj.fuzzyQuery" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="right">
				<el-form :inline="true">
					<el-form-item>
						<el-select placeholder="全部状态" v-model="formObj.orderStatus"  @change="multiSearchClick">
							<el-option label="全部状态" value=""></el-option>
							<el-option :label="list.text" :value="list.value" v-for="list in orderStatusOptions"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="tableBox">
			<el-table  v-loading="isLoading" element-loading-text="拼命加载中"    element-loading-spinner="el-icon-loading"    element-loading-background="rgba(255, 255, 255, 0.8)"
			 ref="multipleTable" border stripe :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
                 <el-table-column label="序号"  width="50">
                	<template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index)}}</template>
                	<!-- <template slot-scope="scope">{{parseInt(searchObj.page-1)*parseInt(searchObj.num) }}</template> -->
                </el-table-column>
				<el-table-column label="图片" width="70">
					<template slot-scope="scope">
						<div class="imgHeader">
							<img :src="IMG_PREV+scope.row.image_file" alt="">
						</div>
					</template>
				</el-table-column>
				<el-table-column label="订单名称" >
					<template slot-scope="scope">{{ scope.row.orderName }}</template>
				</el-table-column>
				<el-table-column label="订单号">
					<template slot-scope="scope">{{ scope.row.orderNumber }}</template>
				</el-table-column>
				<el-table-column label="发单方">
					<template slot-scope="scope">{{ scope.row.fdCompanyName }}</template>
				</el-table-column>
				<el-table-column label="接单方" >
					<template slot-scope="scope">
						<div class="halfCell" v-for="list in scope.row.jdCompanyNameLists">{{list.company_name}}  </div>
					</template>
				</el-table-column>
				<el-table-column label="注册手机号" >
					<template slot-scope="scope">{{ scope.row.userCellphone }}</template>
				</el-table-column>
				<el-table-column label="总数" >
					<template slot-scope="scope">{{ scope.row.orderQuantity }} 件 </template>
				</el-table-column>
				<el-table-column label="总金额" >
					<template slot-scope="scope">{{ scope.row.orderTotalPrice }} 元</template>
				</el-table-column>
				<el-table-column label="发单时间" >
					<template slot-scope="scope">{{ scope.row.orderSubmitTime }}</template>
				</el-table-column>
				<el-table-column label="状态"  >
					<template slot-scope="scope">{{ scope.row.order_status |turnValToText("order_status") }}</template>
				</el-table-column>
				<el-table-column label="订单类型" >
					<template slot-scope="scope">{{ scope.row.orderType |turnValToText("order_type")}}</template>
				</el-table-column>
                <el-table-column label="操作"  width="140">
                	<template slot-scope="scope">
                        <span class="spanBtn" @click="toDetail(scope.row)" v-if="functionViewOrderDetail" >详情</span>
                        <span class="spanBtn orange" @click="toDetailEdit(scope.row)" v-if="functionEditOrder">编辑详情</span>
                        <div  style="margin-top:10px;" v-if="scope.row.order_status == 10300 &&functionChoseFactory" >
                            <span class="spanBtn orange"  @click="toSelectProducer(scope.row)">选生产商</span>

                        </div>
                    </template>
                </el-table-column>
				
			</el-table>
		</div>
		<div class="pageBox">
            {{searchObj.page}} -11
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page.sync="searchObj.page"  
			  :page-size.sync ="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total" background>
			</el-pagination>
		</div>
		<!-- <div class="ceshi">
			ceshi:
			{{searchObj}}
		</div> -->
	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
	export default {
		name: 'adminIndex',
		data() {
			return {
				isLoading:false,
				msg: 'Welcome to Your Vue.js App',
				customerTotal:"",
				formObj:{//用来绑定页面
					fuzzyQuery:'',
					orderStatus:'',
				},
				searchObj:{//用来组装搜索条件并且保存下来
					page:1,
					num:10,
				},
				//表格
				tableData: [],
				multipleSelection: [],
				//分页
				total:0,

			}
		},
		computed:{
            functionViewOrderDetail(){
                return utils.getCurrentFunction().indexOf("viewOrderDetail")>-1
            },
            functionEditOrder(){
                return utils.getCurrentFunction().indexOf("editOrder")>-1
            },
            functionChoseFactory(){
                return utils.getCurrentFunction().indexOf("choseFactory")>-1
            },
            currentFunction(){
                return 
            },
			orderStatusOptions(){
				return wordData.order_status
			},
			IMG_PREV(){
				return api.imgPrev
			},
            powerObj(){//获取权限数据
                let buffer={
                    add:[],
                    modify:[],
                    query:[],
                    delete:[]
                }
                let addArr=utils.getItem('haveAddPowerPageJson')?JSON.parse(utils.getItem('haveAddPowerPageJson')) :[]
                let modifyArr=utils.getItem('haveModifyPowerPageJson')?JSON.parse(utils.getItem('haveModifyPowerPageJson')) :[]
                let queryArr=utils.getItem('haveQueryPowerPageJson')?JSON.parse(utils.getItem('haveQueryPowerPageJson')) :[]
                let deleteArr=utils.getItem('haveDeletePowerPageJson')?JSON.parse(utils.getItem('haveDeletePowerPageJson')) :[]
                buffer.add=addArr
                buffer.modify=modifyArr
                buffer.query=queryArr
                buffer.delete=deleteArr
                return buffer
            },
            currentPageId(){//当前页面id
                let currentPath=this.$route.path
                let result=utils.getCurrentPageId(currentPath)
                return result
            },
		},
		components: {
		},
		methods: {
            toDetailEdit(list){
                let _this=this
                let orderNumber=list.orderNumber
                let orderType=list.orderType
                let fdUserId=list.fdUserId
                if(!orderNumber){
                	this.$message({
                		message: "没有正确获取orderNumber",//接口返回一个页面
                		type: 'error',
                		duration: 1500
                	});
                }else{
                    utils.setSearchObjToSession(_this.searchObj)
                    if(orderType=='cmt'){
                        this.$router.push({ name: 'orderEditCmt', params: { orderNumber: orderNumber,orderType:orderType,fdUserId:fdUserId}})
                    }
                    if(orderType=='oem'){
                        this.$router.push({ name: 'orderEditOem', params: { orderNumber: orderNumber,orderType:orderType,fdUserId:fdUserId}})
                    }
                }
			},
			toSelectProducer(list) {
				let _this=this
				let orderNumber=list.orderNumber
				let orderType=list.orderType
				let userId = list.fdUserId
				if(!orderNumber){
					this.$message({
						message: "没有正确获取orderNumber",//接口返回一个页面
						type: 'error',
						duration: 1500
					});
				}else{
                    utils.setSearchObjToSession(_this.searchObj)
					this.$router.push({ name: 'selectProducer', params: { orderNumber: orderNumber }, query: { id: userId}})
				}
			},
			back(){
				this.$router.back()
			},
			toDetail(list){
                let _this=this
				let orderNumber=list.orderNumber
				let orderType=list.orderType
				let userId = list.fdUserId
				if(!orderNumber){
					this.$message({
						message: "没有正确获取orderNumber",//接口返回一个页面
						type: 'error',
						duration: 1500
					});
				}else{
                    utils.setSearchObjToSession(_this.searchObj)
					this.$router.push({ name: 'orderDetail', params: { orderNumber: orderNumber,orderType:orderType }, query: { id: userId}})
				}
			},
			fuzzySearchClick(){
				this.searchObj={
					fuzzyQuery:this.formObj.fuzzyQuery,
					num:this.searchObj.num,
					page:1,
				}
				this.getTableLists()
			},
			multiSearchClick(){
				this.searchObj={
					orderStatus:this.formObj.orderStatus,
					num:this.searchObj.num,
					page:1,
				}
				this.getTableLists()
			},
			getTableLists(){
				let _this=this
				this.isLoading=true
				ajaxPost('/admin/yijiajiaOrder/orderList',this.searchObj).then(function(res){
					_this.tableData=[]
					_this.isLoading=false
					_this.customerTotal=res.data.totalCount
					if(res.data&&res.data.orderList){
						_this.total=res.data.queryTotalCount
						res.data.orderList.forEach(function(item,index){
							let buffer={}
							//
							buffer.orderName=item.orderName
							buffer.image_file=item.image_file
							buffer.orderNumber=item.orderNumber
							if(item.jiedanCompanyName){
								buffer.jdCompanyNameLists=JSON.parse(item.jiedanCompanyName)
							}else{
								buffer.jdCompanyNameLists=[]
							}
							buffer.fdCompanyName=item.fdCompanyName
							buffer.userCellphone=item.userCellphone
                            buffer.fdUserId=item.fdUserId
							buffer.orderQuantity=item.orderQuantity
							buffer.orderTotalPrice=item.orderTotalPrice
							buffer.orderSubmitTime=item.orderSubmitTime
							buffer.orderType=item.orderType
							buffer.order_status=item.order_status
							_this.tableData.push(buffer)
						})
						
					}
				},function(res){
					_this.isLoading=false
				})
			},
			handleSizeChange(size){//分页：每页n条
				this.searchObj.num=size
				this.searchObj.page=1
				this.getTableLists()
			},
			handleCurrentChange(page){//分页：改变第n页
				this.searchObj.page=page
				this.getTableLists()
			},
			handleSelectionChange(val) {//表格多选框
				this.multipleSelection = val;
				console.log(this.multipleSelection)
			}
		},
		created() {
            console.log("执行created")
			//获取session里存储的搜索条件，并赋值给当前表单
            let _this = this
            let sessionSearch=utils.getSearchObjFromSession()
            if(sessionSearch){
                console.log("session里存储了搜索条件")
                _this.searchObj=sessionSearch
                this.formObj.fuzzyQuery=_this.searchObj.fuzzyQuery
                this.formObj.orderStatus=_this.searchObj.orderStatus
            }
            console.log(_this.searchObj,'mounted里的搜索条件1111')
            this.getTableLists()
		
		},
		mounted(){
            console.log("执行mounted")
		}
	}
</script>

<style scoped lang="scss">
     .halfCell{padding:10px;margin:0;}
    .halfCell:not(:last-child){
        border-bottom:1px solid #ddd;
    }
	.imgHeader{
        border:1px solid #eef; background: #f7f7f7;
		width: 60px; height: 60px;
		img{max-width:100%;max-width: 100%;}
	}
	* {
		// outline: 1px solid blue;
	}
	.container{}
	.searchBox {
		padding:0.25rem 0.25rem 0; 
		.left {
			float: left;
            .fuzzyInput{width: 300px;}
		}

		.right {
			float: right;
		}
	}
	.searchBox:after{content: "";display: block;clear: both;}
	.tableBox{padding:0.25rem;}
</style>



// WEBPACK FOOTER //
// src/pages/order/list.vue